var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertFilled = function SvgAlertFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alert-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB400",
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m.017 13.23q-.42 0-.72.301a1 1 0 0 0-.297.723q0 .42.302.719a1 1 0 0 0 .723.297q.42 0 .72-.301a1 1 0 0 0 .297-.724q0-.42-.303-.719a1 1 0 0 0-.722-.296m0-8.5q-.42 0-.72.298A.99.99 0 0 0 9 5.75v5.5q0 .423.302.722t.723.299q.42 0 .72-.3.297-.299.297-.721v-5.5a.98.98 0 0 0-.303-.722 1 1 0 0 0-.722-.299"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgAlertFilled;